import { render, staticRenderFns } from "./BookingAssistant2.vue?vue&type=template&id=0413c56d&scoped=true&lang=pug&"
import script from "./BookingAssistant2.vue?vue&type=script&lang=ts&"
export * from "./BookingAssistant2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0413c56d",
  null
  
)

export default component.exports